export default async (tabs) => {
  let activeTab = '';
  let firstTab = '';

  for (let tab in tabs) {
    const el = tabs[tab];

    if (!firstTab && el.html_text) {
      firstTab = el.html_text;
    }

    if (el.activeTab) {
      activeTab = el.html_text;
    }

    // --------------------------------------
    // TABS
    const navItem = `
        <div id="${el.html_text}" class="tablinks" onclick="O.changeTab(this.id)">${el.short_text}</div>
      `;
    U.id('sideNav').appendChild(U.createHTMLElementFromString(navItem));

    // --------------------------------------
    // SUB TABS
    if (el.subMenu.length) {
      let subMenuList = '';
      let cntr = 0;

      for (let sub of el.subMenu) {
        cntr++;

        const subItem = `
            <div id="${sub.html_text}" class="subTablinks" onclick="thsSubTab.savePage(this.id)"><span>${cntr}</span> ${sub.short_text}
            </div>
          `;
        // thsSubTab.savePage;
        //thsPage.changeSideNavTab(this.id)
        subMenuList += subItem;
      }

      const subMenu = `
        <div id="subTabs" class="subTabs hide">
          <div class="bar"></div>
          ${subMenuList}
        </div>
        `;

      U.id('sideNav').appendChild(U.createHTMLElementFromString(subMenu));
    }
  }

  return activeTab || firstTab;
};
